import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from './baseQuery';

const home = createApi({
    reducerPath: 'home',
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getDataCharts: builder.mutation({
            query: (param) => ({
                url: 'home/getDataCharts',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        KpiDashboard: builder.mutation({
            query: (param) => ({
                url: 'home/KpiDashboard',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getKpiDashboard: builder.mutation({
            query: (param) => ({
                url: 'home/getKpiDashboard',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getCorporateKPI: builder.mutation({
            query: (param) => ({
                url: 'home/getCorporateKPI',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        saveCorporateKPI: builder.mutation({
            query: (param) => ({
                url: 'home/saveCorporateKPI',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        getImportKPI: builder.mutation({
            query: (param) => ({
                url: 'home/getImportKPI',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
        
        getCorporatePermission: builder.mutation({
            query: (param) => ({
                url: 'home/getCorporatePermission',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),

        phuTran: builder.mutation({
            query: (param) => ({
                url: 'home/phutran',
                method: 'POST',
                body: JSON.stringify(param),
            }),
        }),
    }),
});
export const { useGetDataChartsMutation, useGetKpiDashboardMutation, useGetCorporateKPIMutation
    , useSaveCorporateKPIMutation, useGetImportKPIMutation, useGetCorporatePermissionMutation
    , useKpiDashboardMutation, usePhuTranMutation } = home;
export default home;